<template>
  <section class="scrollable padder">
     
     
        <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(addEdit)" method="post">
            
          <div class="col-md-6">
             <ValidationProvider
               name="Vendor Name"
                  rules="required"
                  v-slot="{ errors }"
               >
            <div class="form-group">
              <label for="vendor-name">
                Vendor Name <span class="required-color">*</span></label
              >
              <input
                type="text"
                class="form-control"
                id="vendor-name"
                v-model="supplierName"
                autocomplete="off"
                data-parsley-pattern-message="This is not a valid vendor name"
                data-parsley-trigger="keyup"
                value=""
                placeholder="Vendor Name"
              />
               <p style="color:red">{{ errors[0] }}</p>
            </div>
          
                </ValidationProvider>
          </div>
              <div class="col-md-3">
                <ValidationProvider name="contact person" rules="required" v-slot="{ errors }">
                <div class="form-group">
                  <label> Contact Person</label>
                 <input
                type="text"
                class="form-control"
                id="contact-person"
                v-model="contactPerson"
                autocomplete="off"
                data-parsley-pattern-message="This is not a valid name"
                data-parsley-trigger="keyup"
                value=""
                placeholder="Contact Person"
              />
               <p style="color:red">{{ errors[0] }}</p>
            </div>
              </ValidationProvider>
              </div>
              <div class="col-md-3">
                <ValidationProvider name="TRN" rules="" v-slot="{ errors }">
                <div class="form-group">
                  <label> TRN</label>
                 <input
                type="text"
                class="form-control"
                id="supplier-trn"
                v-model="supplierTRN"
                autocomplete="off"
                data-parsley-pattern-message="This is not a valid TRN"
                data-parsley-trigger="keyup"
                value=""
                placeholder="TRN"
              />
               <p style="color:red">{{ errors[0] }}</p>
            </div>
              </ValidationProvider>
              </div>
              <div class="col-md-4">
                <ValidationProvider name="vendor-type" rules="required" v-slot="{ errors }">
                <div class="form-group">
                  <label> Vendor Type</label>
                  <select
                    class="form-control"
                    v-model="vendorType"
                    name="vendor_type"
                    style="width: 100%;"
                  >
                    <option id="brand" selected value=""
                      >Choose Type</option
                    >
                    <option
                      v-for="type in typeList"
                      :key="type.type_id"
                      v-bind:value="type.type_id"
                      >{{ type.type_name }}</option
                    >
                  </select>
                   <span style="color:red">{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
              </div>
              <div class="col-md-4">
                <ValidationProvider name="payment-term" rules="required" v-slot="{ errors }">
                <div class="form-group">
                  <label> Payment Term</label>
                  <select
                    class="form-control"
                    v-model="paymentTerm"
                    name="payment_term"
                    style="width: 100%;"
                  >
                    <option id="term" selected value=""
                      >Choose Payment Term</option
                    >
                    <option
                      v-for="term in paymentList"
                      :key="term.term_id"
                      v-bind:value="term.term_id"
                      >{{ term.term_name }}</option
                    >
                  </select>
                   <span style="color:red">{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
              </div>
              <div class="col-md-4">
                <ValidationProvider name="status" rules="required" v-slot="{ errors }">
                <div class="form-group">
                  <label> Status</label>
                  <select
                    class="form-control"
                    v-model="supplierStatus"
                    name="status"
                    style="width: 100%;"
                  >
                    <option id="opt-0" selected value=""
                      >Choose Status</option
                    >
                    <option
                      v-for="status in statusList"
                      :key="status.status_id"
                      v-bind:value="status.status_id"
                      >{{ status.status_name }}</option
                    >
                  </select>
                   <span style="color:red">{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
              </div>
          <div class="col-sm-12">
             <ValidationProvider
               name="Address"
                  rules="required"
                  v-slot="{ errors }"
               >
            <div class="form-group">
              <label for="address">
                Address <span class="required-color">*</span></label
              >
              <input
                type="text"
                class="form-control"
                id="address"
                v-model="supplierAddress"
                autocomplete="off"
                data-parsley-pattern-message="This is not a valid address"
                data-parsley-trigger="keyup"
                value=""
                placeholder="Vendor Address"
              />
               <p style="color:red">{{ errors[0] }}</p>
            </div>          
                </ValidationProvider>
          </div>
              <div class="col-md-4">
                <ValidationProvider name="city" rules="required" v-slot="{ errors }">
                <div class="form-group">
                  <label> City</label>
                 <input
                type="text"
                class="form-control"
                id="city"
                v-model="supplierCity"
                autocomplete="off"
                data-parsley-pattern-message="This is not a valid city anme"
                data-parsley-trigger="keyup"
                value=""
                placeholder="City"
              />
               <p style="color:red">{{ errors[0] }}</p>
            </div>
              </ValidationProvider>
              </div>
              <div class="col-md-4">
                <ValidationProvider name="PO Box" rules="required" v-slot="{ errors }">
                <div class="form-group">
                  <label> P.O Box</label>
                 <input
                type="text"
                class="form-control"
                id="poBox"
                v-model="supplierPO"
                autocomplete="off"
                data-parsley-pattern-message="This is not a valid P.O Box number"
                data-parsley-trigger="keyup"
                value=""
                placeholder="P.O Box"
              />
               <p style="color:red">{{ errors[0] }}</p>
            </div>
              </ValidationProvider>
              </div>
              <div class="col-md-4">
                <ValidationProvider name="Country" rules="required" v-slot="{ errors }">
                <div class="form-group">
                  <label> Country</label>
                  <select
                    class="form-control"
                    v-model="supplierCountry"
                    name="payment_term"
                    style="width: 100%;"
                  >
                    <option id="term" selected value=""
                      >Choose Country</option
                    >
                    <option
                      v-for="country in countryList"
                      :key="country"
                      v-bind:value="country"
                      >{{ country }}</option
                    >
                  </select>
                   <span style="color:red">{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
              </div>
              <div class="col-md-3">
                <ValidationProvider name="phone" rules="required" v-slot="{ errors }">
                <div class="form-group">
                  <label> Phone</label>
                 <input
                type="text"
                class="form-control"
                id="phone"
                v-model="supplierPhone"
                autocomplete="off"
                data-parsley-pattern-message="This is not a valid phone number"
                data-parsley-trigger="keyup"
                value=""
                placeholder="Phone Number"
              />
               <p style="color:red">{{ errors[0] }}</p>
            </div>
              </ValidationProvider>
              </div>
              <div class="col-md-3">
                <ValidationProvider name="fax" rules="required" v-slot="{ errors }">
                <div class="form-group">
                  <label> Fax</label>
                 <input
                type="text"
                class="form-control"
                id="fax"
                v-model="supplierFax"
                autocomplete="off"
                data-parsley-pattern-message="This is not a valid fax number"
                data-parsley-trigger="keyup"
                value=""
                placeholder="Fax Number"
              />
               <p style="color:red">{{ errors[0] }}</p>
            </div>
              </ValidationProvider>
              </div>
              <div class="col-md-3">
                <ValidationProvider name="mobile" rules="" v-slot="{ errors }">
                <div class="form-group">
                  <label> Mobile</label>
                 <input
                type="text"
                class="form-control"
                id="mobile"
                v-model="supplierMobile"
                autocomplete="off"
                data-parsley-pattern-message="This is not a valid mobile number"
                data-parsley-trigger="keyup"
                value=""
                placeholder="Mobile"
              />
               <p style="color:red">{{ errors[0] }}</p>
            </div>
              </ValidationProvider>
              </div>
              <div class="col-md-3">
                <ValidationProvider name="email" rules="" v-slot="{ errors }">
                <div class="form-group">
                  <label> Email</label>
                 <input
                type="text"
                class="form-control"
                id="email"
                v-model="supplierEmail"
                autocomplete="off"
                data-parsley-pattern-message="This is not a valid email"
                data-parsley-trigger="keyup"
                value=""
                placeholder="Email"
              />
               <p style="color:red">{{ errors[0] }}</p>
            </div>
              </ValidationProvider>
              </div>
              <div class="col-md-6">
                <ValidationProvider name="bank" rules="" v-slot="{ errors }">
                <div class="form-group">
                  <label> Bank</label>
                 <input
                type="text"
                class="form-control"
                id="bank"
                v-model="supplierBank"
                autocomplete="off"
                data-parsley-pattern-message="This is not a valid bank name"
                data-parsley-trigger="keyup"
                value=""
                placeholder="Bank Name"
              />
               <p style="color:red">{{ errors[0] }}</p>
            </div>
              </ValidationProvider>
              </div>
              <div class="col-md-6">
                <ValidationProvider name="Account No" rules="" v-slot="{ errors }">
                <div class="form-group">
                  <label> Account No.</label>
                 <input
                type="text"
                class="form-control"
                id="account"
                v-model="supplierAccNo"
                autocomplete="off"
                data-parsley-pattern-message="This is not a valid account number"
                data-parsley-trigger="keyup"
                value=""
                placeholder="Bank Account Number"
              />
               <p style="color:red">{{ errors[0] }}</p>
            </div>
              </ValidationProvider>
              </div>
              <div class="col-md-6">
                <ValidationProvider name="IBAN" rules="" v-slot="{ errors }">
                <div class="form-group">
                  <label> IBAN</label>
                 <input
                type="text"
                class="form-control"
                id="iban"
                v-model="supplierIBAN"
                autocomplete="off"
                data-parsley-pattern-message="This is not a valid IBAN"
                data-parsley-trigger="keyup"
                value=""
                placeholder="IBAN"
              />
               <p style="color:red">{{ errors[0] }}</p>
            </div>
              </ValidationProvider>
              </div>
              <div class="col-md-6">
                <ValidationProvider name="swift" rules="" v-slot="{ errors }">
                <div class="form-group">
                  <label> Swift</label>
                 <input
                type="text"
                class="form-control"
                id="swift"
                v-model="supplierSwift"
                autocomplete="off"
                data-parsley-pattern-message="This is not a valid swift number"
                data-parsley-trigger="keyup"
                value=""
                placeholder="Swift Code"
              />
               <p style="color:red">{{ errors[0] }}</p>
            </div>
              </ValidationProvider>
              </div>
          <div class="modal-footer" style="text-align: right">
           
            <button
              :disabled="saveCat"
              id="btn_save"
              type="submit"
              class="btn btn-success  text-center  "
            >
              Save
            </button>
             <a
              v-on:click="$emit('hide-form')"
              class="btn btn-danger  text-center  "
            >
              Close
            </a>
          </div>
        </form>
        </ValidationObserver>
      
  </section>
</template>

<script>
import api from "../api";
import config from '../config'

export default {
  props: ["supplierId"],
  name: "AddSupplier",
  data() {
    return {
      saveCat: false,
      itemId: '',
      supplierName: '',
      contactPerson: '',
      typeList: [],
      statusList: [],
      paymentList: [],
      countryList: config.countryList,
      vendorType: '',
      paymentTerm: '',
      supplierAddress: '',
      supplierCity: '',
      supplierPO: '',
      supplierCountry: '',
      supplierPhone: '',
      supplierFax: '',
      supplierMobile: '',
      supplierEmail: '',
      supplierTRN: '',
      supplierBank: '',
      supplierAccNo: '',
      supplierIBAN: '',
      supplierSwift: '',
      supplierStatus: '',
      errors : [],
      loading: false,
    };
  },
  methods: {
    getVendorStatus: function() {
      const list = {filter: {}};
      api
        .request("post", "GeneralApis/get_vendor_status", list)
        .then((response) => {
          var data = response.data;
          if (data.errorcode) {
            this.statusList = response.data.values;
          } else {
            this.statusList = data.statusList;
          }
        });
    },
    getVendorTypes: function() {
      const list = {filter: {}};
      api
        .request("post", "GeneralApis/get_vendor_types", list)
        .then((response) => {
          var data = response.data;
          if (data.errorcode) {
            this.typeList = response.data.values;
          } else {
            this.typeList = data.typeList;
          }
        });
    },
    getPaymentTerms: function() {
      const list = {filter: {}};
      api
        .request("post", "GeneralApis/get_payment_terms", list)
        .then((response) => {
          var data = response.data;
          if (data.errorcode) {
            this.paymentList = response.data.values;
          } else {
            this.paymentList = data.termList;
          }
        });
    },
    addEdit() {
       this.loading = false
      this.saveCat = true;
      this.itemId = this.$props.supplierId;
      this.errors = []
      if (!this.supplierName) {
        this.errors.push("Supplier Name is required.");
      }
      if(!this.errors.length){
      const addItem = {
        "supplier-form": {
          supplier_id: this.itemId,
          supplier_name: this.supplierName,
          contact_person: this.contactPerson,
          vendor_type: this.vendorType,
          payment_term: this.paymentTerm,
          supplier_address: this.supplierAddress,
          supplier_city: this.supplierCity,
          supplier_po: this.supplierPO,
          supplier_country: this.supplierCountry,
          supplier_phone: this.supplierPhone,
          supplier_fax: this.supplierFax,
          supplier_mobile: this.supplierMobile,
          supplier_email: this.supplierEmail,
          supplier_trn: this.supplierTRN,
          supplier_bank: this.supplierBank,
          supplier_account_no: this.supplierAccNo,
          supplier_iban: this.supplierIBAN,
          supplier_swift: this.supplierSwift,
          supplier_status: this.supplierStatus
        },
      };
      if (this.itemId > 0) {
        api
          .request("post", "GeneralApis/edit_supplier", addItem)
          .then((response) => {
            var data = response.data;
            if (data.errorcode) {
              this.response = data.errormessage;
              return;
            } else {
              alert("Succesfully Updated");
              this.$emit("hide-form");
              this.$emit("list-items");
            }
          });
      } else {
        api
          .request("post", "GeneralApis/add_supplier", addItem)
          .then((response) => {
            var data = response.data;
            if (data.errorcode) {
              this.response = data.errormessage;
              return;
            } else {
              alert("Succesfully Added");
              this.$emit("hide-form");
              this.$emit("list-items");
            }
          });
      }
      }
    },
    getSupplier: function() {
      var customer_id = this.$props.supplierId;
        (this.supplierName = ""),
        (this.contactPerson = ""),
        (this.supplierAddress = ""),
        (this.supplierCity = ""),
        (this.supplierPO = ""),
        (this.supplierCountry = ""),
        (this.supplierPhone = ""),
        (this.supplierFax = ""),
        (this.supplierMobile = ""),
        (this.supplierEmail = ""),
        (this.supplierTRN = ""),
        (this.supplierBank = ""),
        (this.supplierAccNo = ""),
        (this.supplierIBAN = ""),
        (this.supplierSwift = ""),
        (this.supplierStatus = ""),
        (this.itemId = 0);
      if (customer_id > 0) {
        this.itemId = customer_id;

        const getItem = {
          filter: {
            supplier_id: this.itemId,
          },
        };
        api
          .request("post", "GeneralApis/get_suppliers", getItem)
          .then((response) => {
            var data = response.data;
            if (data.errorcode) {
              this.response = data.errormessage;
              return;
            } else {
              const vendorList = data.supplierList[0];
              this.supplierName = vendorList.supplier_name;
              this.contactPerson = vendorList.contact_person;
              this.paymentTerm = vendorList.payment_term;
              this.vendorType = vendorList.vendor_type;
              this.supplierAddress = vendorList.supplier_address;
              this.supplierCity = vendorList.supplier_city;
              this.supplierPO = vendorList.supplier_po;
              this.supplierCountry = vendorList.supplier_country;
              this.supplierPhone = vendorList.supplier_phone;
              this.supplierFax = vendorList.supplier_fax;
              this.supplierMobile = vendorList.supplier_mobile;
              this.supplierEmail = vendorList.supplier_email;
              this.supplierTRN = vendorList.supplier_trn;
              this.supplierBank = vendorList.supplier_bank;
              this.supplierAccNo = vendorList.supplier_account_no;
              this.supplierIBAN = vendorList.supplier_iban;
              this.supplierSwift = vendorList.supplier_swift;
              this.supplierStatus = vendorList.supplier_status;
            }
          });
      }
    },
  },
  mounted() {
    this.getSupplier();
    this.getPaymentTerms();
    this.getVendorTypes();
    this.getVendorStatus();
  },
};
</script>
